import { IProcessingService, ProcessingService } from "../../../blocs/processing-service/ProcessingService";
import Cubit from "../../../core/utils/cubit";
import { Column } from "./DataTableInterfaces";
import { IDataTableRepository } from "./DataTableRepository";
import { DataTableState } from "./DataTableState";
import { FirebaseDataTableRepository } from "./FirebaseDataTableRepository";

export abstract class IDataTableBloc extends Cubit<DataTableState> {
    abstract load: () => Promise<void>;
    abstract add: (data: Object) => Promise<void>;
    abstract uploadFile: (name: string, blob: Blob) => Promise<string>;
    abstract update: (data: Object, id: string) => Promise<void>;
    abstract delete: (id: string) => Promise<void>;
}

export class DataTableBloc extends IDataTableBloc {
    private repository: IDataTableRepository;
    private processingService: IProcessingService = ProcessingService.getInstance();
    constructor(private name: string, private columns: Column[], repository?: IDataTableRepository) {
        super({
            state: 'LOADING'
        });
        this.repository = repository ?? new FirebaseDataTableRepository(this.name, this.columns);
        this.load();
    }
    load: () => Promise<void> = async () => {
        const oldState = this.state;
        try {
            this.emit({ state: 'LOADING', data: oldState.data });
            const data = await this.repository.getAll();
            this.emit({ state: 'LOADED', data });
        } catch (error) {
            this.emit({ state: 'ERROR', data: oldState.data, error });
        }
    }
    uploadFile: (name: string, blob: Blob) => Promise<string> = async (name:string, blob:Blob) => {
        return await this.repository.uploadFile(name, blob);
    }

    add: (data: Object) => Promise<void> = async (data: Object) => {
        const oldState = this.state;
        try {
            this.emit({ state: 'ADDING', data: oldState.data });
            this.processingService.startProcessing();
            const newData = await this.repository.add(data);
            let oldStateData = this.state.data;
            if (oldStateData === undefined || oldStateData === null) {
                oldStateData = [];
            }
            oldStateData.unshift(newData);
            this.emit({state: 'LOADED', data: oldStateData});
        } catch (error) {
            this.emit({ state: 'ERROR', data: oldState.data });
            console.error(error);
        }
        this.processingService.stopProcessing();
    }
    update: (data: Object, id: string) => Promise<void> = async (data: Object, id: string) => {
        const oldState = this.state;
        try {
            this.emit({ state: 'UPDATING', data: oldState.data });
            this.processingService.startProcessing();
            const newData = await this.repository.update(data, id);
            let oldStateData = this.state.data;
            if (oldStateData === undefined || oldStateData === null) {
                oldStateData = [];
            }
            let updateIndex = oldStateData.findIndex(v => v.id === id);
            oldStateData[updateIndex] = newData;
            this.emit({state: 'LOADED', data: oldStateData});
        } catch (error) {
            this.emit({ state: 'ERROR', data: oldState.data });
        }
        this.processingService.stopProcessing();
    }
    delete: (id: string) => Promise<void> = async (id: string) => {
        const oldState = this.state;
        try {
            this.emit({ state: 'DELETING', data: oldState.data });
            this.processingService.startProcessing();
            await this.repository.delete(id);
            let oldStateData = this.state.data;
            if (oldStateData !== undefined && oldStateData !== null) {
                this.emit({state: 'LOADED', data:  oldStateData.filter(data => data.id !== id)});
            }
        } catch (error) {
            this.emit({ state: 'ERROR', data: oldState.data });
        }
        this.processingService.stopProcessing();
    }
}